import { GtmConstants, GtmDimensions, GtmEventNames } from 'google-tag-manager';
import {
  getBreakpointName,
  getCurrentPageUrl,
  getEnvironmentName,
  getLangCode,
  getAuthenticationStatus,
  getPageCategoryReferrer,
  getPageNameReferrer,
  getPageCategoryFromSessionStorage,
  getPageNameFromSessionStorage,
  getPageReferral,
  getScreenOrientation,
  getTimeStamp,
  getVersionNumber,
  pushToDataLayer
} from './utils/helpers';

export type GTMEventParams = {
  eventAction: string;
  eventCategory: string;
  eventLabel: string;
  eventType: string;
  eventValue: string | null;
};

export type GTMCustomParams = {
  destinationUrl: string | null;
  genericValue1: string | null;
  genericValue2: string | null;
  genericValue3: string | null;
  genericValue4: string | null;
};

export const buildGenericEventCoreParams = async (serverAuthStatus?: boolean) => ({
  [GtmDimensions.businessChannel]: GtmConstants.businessChannel,
  [GtmDimensions.businessType]: GtmConstants.businessType,
  [GtmDimensions.checkInOpen]: GtmConstants.notImplementedValue,
  [GtmDimensions.checkedInStatus]: GtmConstants.notImplementedValue,
  [GtmDimensions.environment]: getEnvironmentName(),
  [GtmDimensions.loggedInStatus]:
    serverAuthStatus !== undefined ? (serverAuthStatus ? 'Yes' : 'No') : await getAuthenticationStatus(),
  [GtmDimensions.pageCategory]: getPageCategoryFromSessionStorage(),
  [GtmDimensions.pageLanguage]: getLangCode(),
  [GtmDimensions.pageName]: getPageNameFromSessionStorage(),
  [GtmDimensions.pageReferral]: getPageReferral(),
  [GtmDimensions.pageUrl]: getCurrentPageUrl(),
  [GtmDimensions.referralPageCategory]: getPageCategoryReferrer(),
  [GtmDimensions.referralPageName]: getPageNameReferrer(),
  [GtmDimensions.responsivePagebreakView]: getBreakpointName(),
  [GtmDimensions.screenOrientation]: getScreenOrientation(),
  [GtmDimensions.siteVersion]: getVersionNumber(),
  [GtmDimensions.testVariant]: GtmConstants.testVariant,
  [GtmDimensions.timestamp]: getTimeStamp(),
  [GtmDimensions.userId]: GtmConstants.notImplementedValue
});

export type GenericEventCoreParams = Awaited<ReturnType<typeof buildGenericEventCoreParams>>;

// see: https://easyjet.atlassian.net/wiki/spaces/DA/pages/349145962/generic_event
export const pushGenericEventData = async (eventParams: GTMEventParams, customParams: Partial<GTMCustomParams> = {}) => {
  const genericEventData = {
    [GtmDimensions.event]: GtmEventNames.genericEvent,
    coreParams: await buildGenericEventCoreParams(),
    customParams: {
      destinationUrl: customParams.destinationUrl ?? null,
      genericValue1: customParams.genericValue1 ?? null,
      genericValue2: customParams.genericValue2 ?? null,
      genericValue3: customParams.genericValue3 ?? null,
      genericValue4: customParams.genericValue4 ?? null
    },
    eventParams
  };
  pushToDataLayer(genericEventData);
};
